import * as React from 'react'
import * as SwitchPrimitives from '@radix-ui/react-switch'

import { cn } from '../../lib/utils'

const MasterSwitch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    ref={ref}
    className={cn(
      'group relative inline-flex h-[30px] w-[60px] shrink-0 cursor-pointer items-center rounded-full',
      'border border-border',
      'bg-background',
      'shadow-[inset_0_1px_3px_rgba(0,0,0,0.5),inset_0_-1px_0_hsl(var(--color-border)/0.4)]',
      'transition-colors duration-200',
      'data-[state=checked]:bg-primary/25',
      'data-[state=checked]:shadow-[inset_0_1px_3px_hsl(160_70%_20%/0.8),inset_0_-1px_0_hsl(var(--color-primary)/0.3)]',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
      'disabled:cursor-not-allowed disabled:opacity-50',
      className,
    )}
    {...props}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none relative block h-6 w-6 rounded-full',
        'translate-x-[2px] rtl:-translate-x-[2px]',
        'data-[state=checked]:translate-x-[32px] rtl:data-[state=checked]:-translate-x-[32px]',
        'transition-transform duration-200 ease-[cubic-bezier(0.5,0,0.2,1.4)]',
        // metallic gradient knob — neutral off
        'bg-[linear-gradient(180deg,hsl(220_5%_88%),hsl(220_5%_65%)_60%,hsl(220_5%_52%))]',
        'shadow-[0_2px_6px_rgba(0,0,0,0.5),inset_0_1px_1px_rgba(255,255,255,0.4),inset_0_-1px_1px_rgba(0,0,0,0.25)]',
        // emerald gradient knob — on
        'group-data-[state=checked]:bg-[linear-gradient(180deg,hsl(160_60%_90%),hsl(160_70%_60%)_60%,hsl(160_70%_42%))]',
        'after:absolute after:inset-[6px] after:rounded-full',
        'after:bg-[radial-gradient(circle_at_30%_30%,hsl(220_5%_95%),hsl(220_5%_70%))]',
        'after:shadow-[inset_0_1px_1px_rgba(255,255,255,0.5)]',
        'group-data-[state=checked]:after:bg-[radial-gradient(circle_at_30%_30%,hsl(160_70%_95%),hsl(160_70%_55%))]',
      )}
    />
  </SwitchPrimitives.Root>
))
MasterSwitch.displayName = 'MasterSwitch'

export { MasterSwitch }
